// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__3E2hn","home":"Breadcrumb_home__3E_mk","separator":"Breadcrumb_separator__BPYCE"};